/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import PreventiveTaskExecutionFormFields from './PreventiveTaskExecutionFormFields';

import { RESOURCE_EXECUTION_MODE } from '../../../../config/constants';

const FORM_NAME = 'PreventiveTaskExecutionForm';

const selector = formValueSelector(FORM_NAME);

const getSelectValue = (field) => {
  if (field && typeof field === 'object') {
    return field.value;
  }

  return field;
};

const validateGroupedResources = (values) => {
  const errors = {};

  const selectedMode = getSelectValue(values.resourceExecutionMode);

  if (selectedMode !== RESOURCE_EXECUTION_MODE.GROUPED.value) {
    return errors;
  }

  const groups = Array.isArray(values.resourceGroups)
    ? values.resourceGroups
    : [];

  const groupErrors = [];
  const resourceGroupById = new Map();

  if (!groups.length) {
    groupErrors._error = 'Agregue al menos un grupo de ejecución';
  }

  groups.forEach((group, groupIndex) => {
    const currentGroup = group || {};
    const currentErrors = {};

    const selectedResources = Array.isArray(currentGroup.resources)
      ? currentGroup.resources
      : [];

    if (!selectedResources.length) {
      currentErrors.resources = 'Seleccione al menos un recurso';
    }

    selectedResources.forEach((resource) => {
      const resourceId = getSelectValue(resource);

      if (
        resourceId === undefined ||
        resourceId === null ||
        resourceId === ''
      ) {
        return;
      }

      if (resourceGroupById.has(resourceId)) {
        const previousGroup = resourceGroupById.get(resourceId) + 1;

        const resourceLabel =
          resource && typeof resource === 'object'
            ? resource.label
            : resourceId;

        currentErrors.resources =
          `El recurso "${resourceLabel}" ya fue seleccionado ` +
          `en el grupo ${previousGroup}`;

        return;
      }

      resourceGroupById.set(resourceId, groupIndex);
    });

    if (
      currentGroup.startedDate &&
      currentGroup.completedDate &&
      new Date(currentGroup.completedDate).getTime() <
        new Date(currentGroup.startedDate).getTime()
    ) {
      currentErrors.completedDate =
        'La culminación no puede ser menor que el inicio';
    }

    if (Object.keys(currentErrors).length) {
      groupErrors[groupIndex] = currentErrors;
    }
  });

  if (groupErrors.length || groupErrors._error) {
    errors.resourceGroups = groupErrors;
  }

  return errors;
};

export const PreventiveTaskExecutionForm = ({
  handleSubmit,
  loading,
  initialValues,
  resourceExecutionModeValue,
  resourceGroupsValue,
}) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <PreventiveTaskExecutionFormFields
        initialValues={initialValues}
        resourceExecutionMode={resourceExecutionModeValue}
        resourceGroups={resourceGroupsValue}
      />

      <FormFooter
        saveButtonDisabled={loading}
        saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
      />
    </Form>
  );
};

PreventiveTaskExecutionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  initialValues: PropTypes.shape({}),
  resourceExecutionModeValue: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.string,
  ]),
  resourceGroupsValue: PropTypes.arrayOf(PropTypes.shape({})),
};

PreventiveTaskExecutionForm.defaultProps = {
  loading: false,
  initialValues: null,
  resourceExecutionModeValue: null,
  resourceGroupsValue: [],
};

const mapStateToProps = (state) => ({
  preventiveTaskValue: selector(state, 'preventiveTaskId'),

  preventiveTaskAssigneeValue: selector(state, 'preventiveTaskAssigneeId'),

  resourceExecutionModeValue: selector(state, 'resourceExecutionMode'),

  resourceGroupsValue: selector(state, 'resourceGroups') || [],
});

const formComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate: validateGroupedResources,
})(PreventiveTaskExecutionForm);

export default connect(mapStateToProps)(formComponent);
